import { StaticImage } from "gatsby-plugin-image";
import React, { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { useLocation } from "@reach/router";

import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
} from "./NavbarElements";
import "./Navbar.scss";

const Navbar = () => {
  const location = useLocation();

  const [click, setClick] = useState(false);
  const [scroll, setScroll] = useState(false);

  const handleClick = () => setClick(!click);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  useEffect(() => {
    changeNav();
    window.addEventListener("scroll", changeNav);

    return () => {
      window.removeEventListener("scroll", changeNav);
    };
  }, []);

  const isActiveLink = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }

    return location.pathname.startsWith(path);
  };

  const servicePaths = [
    "/our-services",
    "/stevedoring-and-arrastre",
    "/loading",
    "/transit-storage",
    "/cargo-delivery",
    "/terminal-management",
    "/it-services",
  ];

  const isServicesActive = servicePaths.some((path) =>
    location.pathname.startsWith(path),
  );

  return (
    <IconContext.Provider value={{ color: "#141414" }}>
      <Nav className="main-nav" active={scroll} click={click}>
        <NavbarContainer>
          <NavLogo to="/">
            <StaticImage
              src="../../images/star-logo.png"
              width={40}
              quality={95}
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="star logo"
              fit="contain"
              className="nav-logo"
            />
          </NavLogo>

          <MobileIcon onClick={handleClick}>
            {click ? <FaTimes style={{ color: "#fff" }} /> : <FaBars />}
          </MobileIcon>

          <NavMenu click={click}>
            <NavItem>
              <NavLinks
                className={isActiveLink("/") ? "active-link" : ""}
                to="/"
              >
                Home
              </NavLinks>
            </NavItem>

            <NavItem>
              <NavLinks
                className={isActiveLink("/history") ? "active-link" : ""}
                to="/history"
              >
                History
              </NavLinks>
            </NavItem>

            <NavItem>
              <NavLinks
                className={isActiveLink("/our-footprint") ? "active-link" : ""}
                to="/our-footprint"
              >
                Our Footprint
              </NavLinks>
            </NavItem>

            <NavItem className="services-desktop-only">
              <div className="service-dd">
                <button
                  className={`dropbtn ${isServicesActive ? "active-link" : ""}`}
                  type="button"
                  aria-haspopup="menu"
                >
                  Our Services
                </button>
                <div className="dropdown-content" role="menu">
                  <NavLinks to="/stevedoring-and-arrastre">
                    Stevedoring & Arrastre
                  </NavLinks>
                  <NavLinks to="/loading">Loading</NavLinks>
                  <NavLinks to="/transit-storage">Transit Storage</NavLinks>
                  <NavLinks to="/cargo-delivery">Cargo Delivery</NavLinks>
                  <NavLinks to="/terminal-management">
                    Terminal Development & Management
                  </NavLinks>
                  <NavLinks to="/it-services">IT Services</NavLinks>
                </div>
              </div>
            </NavItem>

            <NavItem className="services-mobile-only">
              <NavLinks
                className={isServicesActive ? "active-link" : ""}
                to="/our-services"
              >
                Our Services
              </NavLinks>
            </NavItem>

            <NavItem>
              <NavLinks
                className={
                  isActiveLink("/affiliate-companies") ? "active-link" : ""
                }
                to="/affiliate-companies"
              >
                Affiliate Companies
              </NavLinks>
            </NavItem>

            <NavItem>
              <NavLinks
                className={isActiveLink("/careers") ? "active-link" : ""}
                to="/careers"
              >
                Careers
              </NavLinks>
            </NavItem>

            <NavItem>
              <NavLinks target="_blank" to="https://sg-portal.aesi.io/login">
                Login to Apollo
              </NavLinks>
            </NavItem>

            <NavItem>
              <NavLinks
                className={isActiveLink("/contact-us") ? "active-link" : ""}
                to="/contact-us"
              >
                Contact Us
              </NavLinks>
            </NavItem>
          </NavMenu>
        </NavbarContainer>
      </Nav>
    </IconContext.Provider>
  );
};

export default Navbar;
